<template lang="pug">
.form-send-target.register-row
  .register-group
    .register-key
      span.key-name {{ keyName }}
      span.validation-label(v-if="required == true") 必須
      span.option-text.font-strong-color {{ optionText }}
    .register-value.flex-wrap.send-targets
      // loading or target select button
      .loading(v-if="isBusy")
        b-spinner.spinner
        span 宛先読込中...
      .loaded(v-else)
        button.btn.target-select-btn.mr-2(@click="onTargetSelect") 宛先選択
      // selected targets
      .send-target.d-flex.mr-2(v-for="target in _value" v-if="target.isTarget")
        span.target-name.align-self-center {{ target.label }}
        b-badge.delete-btn.align-self-center(variant="secondary" @click="onDeleteMember(target)") X

    .error-messages(v-if="errors.has(name)")
      div(v-for="error in errors.collect(name)")
        label.error-message {{ error }}
        br
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";

/**
 * ### 宛先選択ボタンコンポーネント
 */
@Component
export default class FormSendTarget extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  /** 宛先候補 */
  @Prop({ required: true })
  value!: Array<SendTarget>;

  /** 読込み中 */
  @Prop({ required: true })
  isBusy!: boolean;

  /** 項目名 */
  @Prop({ required: true, type: String })
  keyName!: string;

  /** 必須か */
  @Prop({ default: false, type: Boolean })
  required!: boolean;

  /** name属性の値 */
  @Prop({ required: true, type: String })
  name!: string;

  /** 説明文 */
  @Prop({ default: "", type: String })
  optionText!: string;

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _value(): Array<SendTarget> {
    return this.value;
  }

  /**
   * ### 宛先ボタン押下
   */
  public onTargetSelect(): void {
    this.$emit("onTargetSelect");
    return;
  }

  /**
   * ### 宛先の削除(x)ボタン押下
   */
  public onDeleteMember(deleteTarget: SendTarget): void {
    this.$emit("onDeleteMember", deleteTarget);
    return;
  }
}

export interface SendTarget {
  /** 対象か否か */
  isTarget: boolean;
  /** 一意に識別するためのkey */
  key: string;
  /** 保険者番号_介護保険被保険者番号の複合key */
  insuredNumberKey: string | null;
  /** 表示名 */
  label: string;
  /** 元データ */
  source: any;
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";
@import "../../../styles/pc/_mixin.scss";

.form-send-target {
  .option-text {
    margin-left: 8px;
  }
  .send-targets {
    max-width: 600px;

    .send-target-select-btn {
      margin: 0 8px 4px 0;
    }
    .send-target {
      display: inline-block;
      padding: 7px;
      border-radius: 3px;
      transition: all 0.2s;
      border: 1px solid $form-border-color;

      .target-name {
        margin: 0 8px 0 0 !important;
      }
      .delete-btn {
        margin: 0 !important;
        font-size: 14px !important;
        cursor: pointer;
      }
    }
  }
}
</style>
